module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    class: _vm.isLogin ? 'Form is-login' : 'Form',
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition-group', {
    staticClass: "Form__transition-group",
    attrs: {
      "name": "u-anim-fade-delayed",
      "tag": "div"
    }
  }, [(_vm.success) ? _c('div', {
    key: "success",
    ref: "formSuccess",
    staticClass: "Form__container"
  }, [_c('div', {
    staticClass: "Form__section Form__section--success"
  }, [(_vm.showConfirmation) ? _c('div', {
    staticClass: "Form__section-inner"
  }, [_c('TitleComponent', {
    staticClass: "Form__confirmationTitle",
    attrs: {
      "level": 2,
      "id": _vm.confirmationTitle
    }
  }, [_vm._v(_vm._s(_vm.confirmationTitle))]), _vm._v(" "), _c('RichText', {
    attrs: {
      "content": _vm.confirmationText
    }
  }), _vm._v(" "), (_vm.showNewsletterSignup && _vm.formState['Newsletter']) ? _c('p', [_c('br'), _c('br'), _vm._v(_vm._s(_vm.options.newsletter_signup_confirmation_text))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFeedbackForm && _vm.feedbackForm) ? _c('Form', {
    attrs: {
      "name": "feedbackForm",
      "formFields": _vm.feedbackForm.form_fields,
      "buttonText": _vm.feedbackForm.button_text,
      "formEndpoint": _vm.feedbackForm.form_endpoint,
      "showConfirmation": _vm.feedbackForm.show_confirmation,
      "confirmationTitle": _vm.feedbackForm.confirmation_title,
      "confirmationText": _vm.feedbackForm.confirmation_text,
      "gdpr": false,
      "showNewsletterSignup": false,
      "showFeedbackForm": false,
      "feedbackForm": false
    }
  }) : _vm._e()], 1)]) : _c('div', {
    key: "else",
    staticClass: "Form__container"
  }, [_vm._l((_vm.formFields), function(field, index) {
    return _c('div', {
      key: index,
      class: ("Form__section Form__section--" + (field.type))
    }, [(field.type === 'description') ? _c('div', [_c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [(field.type === 'description') ? _c('RichText', {
      attrs: {
        "content": field.content
      }
    }) : _vm._e()], 1)]) : (field.type === 'street_number') ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "Form__section-inner Form__section-inner--street"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_street'),
        "cleanLabel": "street",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--street"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Strasse']),
        expression: "formState['Strasse']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--street",
      attrs: {
        "type": "text",
        "id": "street",
        "name": _vm.getStringTranslation('form_street')
      },
      domProps: {
        "value": (_vm.formState['Strasse'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Strasse', $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "Form__section-inner Form__section-inner--street-number"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_number'),
        "cleanLabel": "street-number",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--street-number"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Strasse Nr']),
        expression: "formState['Strasse Nr']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--street-number",
      attrs: {
        "type": "text",
        "id": "street-number",
        "name": _vm.getStringTranslation('form_number')
      },
      domProps: {
        "value": (_vm.formState['Strasse Nr'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Strasse Nr', $event.target.value)
        }
      }
    })])], 1)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_street'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_street'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_street'))) + "\n          ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_number'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_number'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_number'))) + "\n          ")])]) : (field.type === 'zip_place') ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "Form__section-inner Form__section-inner--zip"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_zip'),
        "cleanLabel": "zip",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--zip"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['PLZ']),
        expression: "formState['PLZ']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation('zip') : false),
        expression: "field.required ? constructValidation('zip') : false"
      }],
      staticClass: "Form__field Form__field--zip",
      attrs: {
        "type": "text",
        "id": "zip",
        "name": _vm.getStringTranslation('form_zip')
      },
      domProps: {
        "value": (_vm.formState['PLZ'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'PLZ', $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "Form__section-inner Form__section-inner--place"
    }, [_c('FormLabel', {
      attrs: {
        "label": _vm.getStringTranslation('form_city'),
        "cleanLabel": "place",
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--place"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Ort']),
        expression: "formState['Ort']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      staticClass: "Form__field Form__field--place",
      attrs: {
        "type": "text",
        "id": "place",
        "name": _vm.getStringTranslation('form_city')
      },
      domProps: {
        "value": (_vm.formState['Ort'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Ort', $event.target.value)
        }
      }
    })])], 1)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_zip'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_zip'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_zip'))) + "\n          ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(_vm.getStringTranslation('form_city'))),
        expression: "veeValidateErrors.has(getStringTranslation('form_city'))"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.getStringTranslation('form_city'))) + "\n          ")])]) : (field.type === 'swiss_only') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": "Land",
        "cleanLabel": "country"
      }
    }), _vm._v(" "), _c('div', {
      class: "Form__field-wrapper Form__field-wrapper--text"
    }, [_c('input', {
      class: "Form__field Form__field--text",
      attrs: {
        "value": "Schweiz",
        "type": "text",
        "id": "country",
        "name": "country",
        "readonly": ""
      }
    })])], 1) : (field.type === 'quantity') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": "Anzahl *",
        "cleanLabel": "quantity"
      }
    }), _vm._v(" "), _c('div', {
      class: "Form__field-wrapper Form__field-wrapper--text"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState['Anzahl']),
        expression: "formState['Anzahl']"
      }],
      class: "Form__field Form__field--quantity",
      attrs: {
        "type": "number",
        "min": "1",
        "id": "quantity",
        "name": "quantity"
      },
      domProps: {
        "value": (_vm.formState['Anzahl'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, 'Anzahl', $event.target.value)
        }
      }
    })])], 1) : (field.type === 'radiogroup') ? _c('div', [_c('fieldset', {
      staticClass: "Form__section-fieldset"
    }, [_c('legend', {
      staticClass: "Form__section-legend"
    }, [_c('TitleComponent', {
      staticClass: "Form__section-title",
      attrs: {
        "level": 4
      }
    }, [_vm._v("\n                " + _vm._s(field.label) + "\n                "), (field.required) ? _c('abbr', {
      staticClass: "Form__label-required",
      attrs: {
        "title": "required"
      }
    }, [_vm._v("*")]) : _vm._e()])], 1), _vm._v(" "), _vm._l((field.radio_group_options), function(option, index) {
      return _c('div', {
        key: index,
        staticClass: "Form__section-radio-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.formState['Option']),
          expression: "formState['Option']"
        }],
        staticClass: "Form__section-radio-item-input",
        attrs: {
          "type": "radio",
          "name": field.label,
          "id": ("radio-item-" + index)
        },
        domProps: {
          "value": option.option,
          "checked": _vm._q(_vm.formState['Option'], option.option)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.formState, 'Option', option.option)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "Form__label Form__label--radio",
        attrs: {
          "for": ("radio-item-" + index)
        }
      }, [_vm._v("\n                " + _vm._s(option.option) + "\n              ")]), _vm._v(" "), _c('div', {
        style: ({
          clear: 'both'
        })
      })])
    })], 2)]) : (field.type === 'textarea') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation() : false),
        expression: "field.required ? constructValidation() : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.label, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1) : (field.type === 'password') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.type]),
        expression: "formState[field.type]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm.constructValidation(field.type)),
        expression: "constructValidation(field.type)"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "password",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.type])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.type, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.passwordError),
        expression: "passwordError"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.getStringTranslation('error_wrongpassword')) + "\n            ")])])], 1) : (field.type === 'checkbox') ? _c('div', [_c('div', {
      staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? 'required' : false),
        expression: "field.required ? 'required' : false"
      }],
      staticClass: "Form__field--checkbox",
      attrs: {
        "type": "checkbox",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "checked": Array.isArray(_vm.formState[field.label]) ? _vm._i(_vm.formState[field.label], null) > -1 : (_vm.formState[field.label])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formState[field.label],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.formState, field.label, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.formState, field.label, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.formState, field.label, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "Form__label--checkbox",
      attrs: {
        "for": _vm.cleanLabel(field.label)
      }
    }, [_vm._v("\n              " + _vm._s(field.required ? '* ' : '') + _vm._s(field.label) + "\n            ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])]) : (field.type === 'email') ? _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState.email),
        expression: "formState.email"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation(field.type) : false),
        expression: "field.required ? constructValidation(field.type) : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "text",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1) : _c('div', [_c('FormLabel', {
      attrs: {
        "label": field.label,
        "cleanLabel": _vm.cleanLabel(field.label),
        "required": field.required
      }
    }), _vm._v(" "), _c('div', {
      class: ("Form__field-wrapper Form__field-wrapper--" + (field.type))
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formState[field.label]),
        expression: "formState[field.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (field.required ? _vm.constructValidation(field.type) : false),
        expression: "field.required ? constructValidation(field.type) : false"
      }],
      class: ("Form__field Form__field--" + (field.type)),
      attrs: {
        "type": "text",
        "id": _vm.cleanLabel(field.label),
        "name": field.label
      },
      domProps: {
        "value": (_vm.formState[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.formState, field.label, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.veeValidateErrors.has(field.label)),
        expression: "veeValidateErrors.has(field.label)"
      }],
      staticClass: "Form__error"
    }, [_vm._v("\n              " + _vm._s(_vm.veeValidateErrors.first(field.label)) + "\n            ")])])], 1)])
  }), _vm._v(" "), (_vm.showNewsletterSignup && _vm.options && _vm.options.newsletter_signup_title && _vm.options.newsletter_signup_text && _vm.options.newsletter_signup_confirmation_text) ? _c('div', {
    staticClass: "Form__section Form__section--gdpr"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.options.newsletter_signup_title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formState['Newsletter']),
      expression: "formState['Newsletter']"
    }],
    staticClass: "Form__field--checkbox",
    attrs: {
      "type": "checkbox",
      "id": 'newsletter',
      "name": 'newsletter'
    },
    domProps: {
      "checked": Array.isArray(_vm.formState['Newsletter']) ? _vm._i(_vm.formState['Newsletter'], null) > -1 : (_vm.formState['Newsletter'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formState['Newsletter'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formState, 'Newsletter', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formState, 'Newsletter', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formState, 'Newsletter', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "Form__label--checkbox",
    attrs: {
      "for": 'newsletter'
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getStringTranslation('newsletter_signup')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "Form__info"
  }, [_vm._v("\n            " + _vm._s(_vm.options.newsletter_signup_text) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.gdpr && _vm.gdpr.gdpr) ? _c('div', {
    staticClass: "Form__section Form__section--gdpr"
  }, [(_vm.getStringTranslation('gdpr')) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.getStringTranslation('gdpr')) + " *\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Form__field-wrapper Form__field-wrapper--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formState['Datenschutz']),
      expression: "formState['Datenschutz']"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "Form__field--checkbox",
    attrs: {
      "type": "checkbox",
      "id": _vm.cleanLabel(_vm.gdprFieldName),
      "name": _vm.gdprFieldName
    },
    domProps: {
      "checked": Array.isArray(_vm.formState['Datenschutz']) ? _vm._i(_vm.formState['Datenschutz'], null) > -1 : (_vm.formState['Datenschutz'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formState['Datenschutz'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formState, 'Datenschutz', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formState, 'Datenschutz', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formState, 'Datenschutz', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "Form__label--checkbox",
    attrs: {
      "for": _vm.cleanLabel(_vm.gdprFieldName)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.gdpr.gdpr_checkbox_label) + "\n          ")]), _vm._v(" "), (_vm.gdpr.gdpr) ? _c('span', {
    staticClass: "Form__info",
    domProps: {
      "innerHTML": _vm._s(_vm.gdpr.gdpr)
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeValidateErrors.has(_vm.gdprFieldName)),
      expression: "veeValidateErrors.has(gdprFieldName)"
    }],
    staticClass: "Form__error"
  }, [_vm._v("\n            " + _vm._s(_vm.veeValidateErrors.first(_vm.gdprFieldName)) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Form__section"
  }, [_c('button', {
    staticClass: "Form__button",
    on: {
      "click": _vm.submitHandler
    }
  }, [_c('span', {
    staticClass: "Form__button-inner"
  }, [_vm._v(_vm._s(_vm.buttonText))])])])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685889aa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form/Form.vue
// module id = 240
// module chunks = 1